module.exports = __webpack_public_path__ + "static/img/ip-left.be352c07.png";